var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hubspot 1",
    clipPath: "url(#clip0_97_801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8716 9.5214C21.0071 8.86105 19.9908 8.42799 18.9158 8.26183H18.9204V5.29708C19.7214 4.92296 20.2349 4.12042 20.2388 3.23634V3.16705C20.2354 1.90704 19.2148 0.886391 17.9547 0.883021H17.8855C16.6254 0.886391 15.6048 1.90704 15.6014 3.16705V3.23634C15.6053 4.12042 16.1188 4.92296 16.9198 5.29708V8.26803C15.7916 8.44054 14.7289 8.90812 13.8395 9.62335L5.68594 3.2733C6.05669 1.88532 5.23199 0.459584 3.844 0.088832C2.45601 -0.28192 1.03028 0.542738 0.659526 1.93073C0.288774 3.31871 1.11343 4.74445 2.50147 5.1152C3.16514 5.29245 3.87193 5.20006 4.46768 4.85807L12.4841 11.0987C11.0064 13.3282 11.0461 16.2355 12.5842 18.4236L10.1446 20.8632C9.94878 20.8009 9.74488 20.7676 9.53936 20.7647C8.36978 20.7647 7.42168 21.7128 7.42168 22.8823C7.42168 24.0519 8.36978 25.0001 9.53936 25.0001C10.7089 25.0001 11.657 24.0519 11.657 22.8823C11.6542 22.6769 11.621 22.4729 11.5585 22.2771L13.9719 19.8637C16.8278 22.0451 20.9114 21.4984 23.0929 18.6424C25.2744 15.7864 24.7276 11.7028 21.8716 9.5214ZM17.9239 18.0309L17.9162 18.0294C16.0721 18.0251 14.5806 16.5267 14.5849 14.6826C14.5892 12.8385 16.0876 11.3471 17.9316 11.3513C19.7733 11.3555 21.2638 12.8502 21.263 14.6919C21.2629 16.536 19.768 18.0309 17.9239 18.0309Z",
    fill: "#FF7B57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.bfa7f235f728d27b08f2373a39171df8.svg";
export { ForwardRef as ReactComponent };